import { config } from './permissionsConfig';

export const requireUser = (store) => (next) => (action) => {
  // console.log('store ->'); console.log(store);
  // console.log('next ->'); console.log(next);
  // console.log('action ->'); console.log(action);
  //console.log('auth ->'); console.log(store.getState().auth.role);
  if (store.getState().auth.role !== 'user') {
    if (config.user.includes(action.type)) {
      store.dispatch({ type: 'PERMISSIONS_ERROR', payload: action });
    } else {
      next(action);
    }
  } else {
     next(action);
  }
};

export const requireManager = (store) => (next) => (action) => {
  // console.log('store ->'); console.log(store);
  // console.log('next ->'); console.log(next);
  // console.log('action ->'); console.log(action);
  // console.log('auth ->'); console.log(store.getState().auth.role);
  //  if (store.getState().auth.role !== 'manager') {
  //   if (config.manager.includes(action.type)) {
  //     store.dispatch({ type: 'PERMISSIONS_ERROR', payload: action });
  //   } else {
  //     next(action);
  //   }
  //  } else {
     next(action);
  //  }
};

export const requireAdmin = (store) => (next) => (action) => {
   if (store.getState().auth.role !== 'admin') {
  //   if (config.admin.includes(action.type)) {
  //     store.dispatch({ type: 'PERMISSIONS_ERROR', payload: action });
  //   } else {
  //     next(action);
  //   }
   } else {
     next(action);
   }
};
